import { AppState } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setAppForwardUrlReducer = (state: AppState, action: PayloadAction<string | undefined>) => {
  state.forwardUrl = action.payload;
};

export default setAppForwardUrlReducer;
